module.exports = __webpack_public_path__ + "static/zorba-the-greek-ec78ef7ed56bd67ff4ad33705f902337.jpg";